import React from 'react';
import styled from 'styled-components';

import { Dialog } from '../Dialog/Dialog';
import Button from '../Button/Button';

const AlertMessageWrap = styled.div`
  width: 100%;
  padding: 10px 0;
  text-align: center;
  white-space: pre-line;
  line-height: 25px;
`;

function AlertComponent(props) {
  const { message, close, maxWidth, buttonText } = props;

  const actions = [
    <Button key="ok" color="primary" onClick={close}>
      {buttonText || 'Close'}
    </Button>,
  ];

  return (
    <Dialog open={!!message} actions={actions} fullWidth maxWidth={maxWidth || 'xs'}>
      <AlertMessageWrap>{message}</AlertMessageWrap>
    </Dialog>
  );
}

export default AlertComponent;
